
import Vue from "vue";
import { FrontendFunc } from "@/models/frontend-func";
import { IDataTableColumn } from "winfakt-vue-components";
import { FrontendScriptsService } from "@/services/frontend-scripts-service";

export default Vue.extend({
	data(){
		return {
			scripts: [] as FrontendFunc[],
			isFetching: false,
			selectedItems: [] as FrontendFunc[]
		};
	},
	computed: {
		columns():IDataTableColumn[] {
			let result:IDataTableColumn[] = [
				{
					name: "ID",
					property: "ID",
					width: "80px"
				},
				{
					name: "Naam",
					property: "Name",
					width: "200px"
				},
				{
					name: "Omschrijving",
					property: "Description",
					width: "800px"
				}
			];
			result.forEach(r=>r.disableSorting = true);
			return result;
		},
		showTotalRecordsText():string {
			return "Aantal lijnen: " + this.scripts.length;
		},
	},
	methods: {
		async fetch(){
			this.isFetching = true;
			try{
				this.scripts = await FrontendScriptsService.getFrontendSharedFuncs();
			}catch(err){
			}
			this.isFetching = false;
		},
		editClicked(){
			this.$router.push(`/scripts/edit/${this.selectedItems[0].ID}`);
		},
		async deleteClicked(){
			let toDeleteItems = [...this.selectedItems];
			for (let item of toDeleteItems){
				await FrontendScriptsService.deleteFrontendSharedFunc(item);
				let i = this.selectedItems.findIndex(i=>item.ID ==i.ID);
				if (i != -1) {
					this.selectedItems.splice(i,1);
				}
				i = this.scripts.findIndex(i=>item.ID ==i.ID);
				if (i != -1) {
					this.scripts.splice(i,1);
				}
			}
			this.fetch();
		}
	},
	created(){
		this.fetch();
	}
});
